<template>
    <div class="componentWrapper">
        <div class="texts">
            <span>{{ $t('contact.smallTitle', currentLang) }}</span>
            <h1>{{ $t('contact.title', currentLang) }}</h1>
            <div class="singleContactData">
                <i class="pi pi-map-marker"></i>
                <div>
                    <p>{{ $t('company.address', currentLang) }}</p>
                    <span @click="openGoogleMaps()" style="cursor: pointer">{{ $t('contact.form.map', currentLang) }}</span>
                </div>
            </div>
            <div class="singleContactData">
                <i class="pi pi-inbox"></i>
                <div>
                    <p>{{ $t('company.email', currentLang) }}</p>
                    <span @click="$emit('openContactPopup')" style="cursor: pointer">{{ $t('contact.form.send', currentLang) }}</span>
                </div>
            </div>
            <div class="singleContactData">
                <i class="pi pi-phone"></i>
                <div>
                    <p>{{ $t('company.number', currentLang) }}</p>
                    <span>{{ $t('contact.form.call', currentLang) }}</span>
                </div>
            </div>
        </div>
        <div class="contactBox">
            <div style="display: flex; flex-wrap: wrap; row-gap: 25px; justify-content: space-between">
                <div class="flex flex-col gap-2" >
                    <label for="username">{{ $t('contact.form.name', currentLang) }}</label>
                    <IconField style="margin-top: 10px">
                        <InputIcon class="pi pi-user" />
                        <InputText id="username" :placeholder="$t('contact.form.placeholder', currentLang)" v-model="formData.name"/>
                    </IconField>
                </div>
                <div class="flex flex-col gap-2" >
                    <label for="username">{{ $t('contact.form.business', currentLang) }}</label>
                    <IconField style="margin-top: 10px">
                        <InputIcon class="pi pi-briefcase" />
                        <InputText id="username" :placeholder="$t('contact.form.placeholder', currentLang)" v-model="formData.business"/>
                    </IconField>
                </div>
                <div class="flex flex-col gap-2">
                    <label for="username">{{ $t('contact.form.email', currentLang) }}</label>
                    <IconField style="margin-top: 10px">
                        <InputIcon class="pi pi-envelope" />
                        <InputText id="username" :placeholder="$t('contact.form.placeholder', currentLang)" v-model="formData.email"/>
                    </IconField>
                </div>
                <div class="flex flex-col gap-2">
                    <label for="username">{{ $t('contact.form.mobile', currentLang) }}</label>
                    <IconField style="margin-top: 10px">
                        <InputIcon class="pi pi-phone" />
                        <InputText id="username" :placeholder="$t('contact.form.placeholder', currentLang)" v-model="formData.mobile"/>
                    </IconField>
                </div>
            </div>
            <div class="flex flex-col gap-2" style="margin-top: 25px">
                <label for="username">{{ $t('contact.form.message', currentLang) }}</label>
                <br>
                <Textarea style="margin-top: 10px; width: 100%; height: 130px" id="username" v-model="formData.message" :placeholder="$t('contact.form.placeholder', currentLang)" />
            </div>
            <div v-if="submitStatus" :class="['submit-status', submitStatus.success ? 'success' : 'error']">
                {{ submitStatus.message }}
            </div>
            <Button 
                icon="pi pi-send" 
                :label="$t('buttons.sendMessage', currentLang)" 
                severity="contrast" 
                style="margin-top: 20px; width: 250px; background-color: steelblue; border: 1px solid steelblue" 
                @click="submitForm"
                :loading="loading"
            />
        </div>
    </div>
</template>
  
<script>
import Button from 'primevue/button';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import Textarea from 'primevue/textarea';

export default {
    name: 'ourServices',
    components: {
        Button,
        InputText,
        InputIcon,
        IconField,
        Textarea
    },
    data() {
        return {
            formData: {
                name: '',
                business: '',
                email: '',
                mobile: '',
                message: ''
            },
            loading: false,
            submitStatus: null
        };
    },
    computed: {
        currentLang() {
            return this.$route.params.lang || 'et'; // Default to 'et' if no lang param
        }
    },
    methods: {
        async submitForm() {
            // Validate form
            if (!this.formData.name || !this.formData.email || !this.formData.message) {
                this.submitStatus = {
                    success: false,
                    message: this.$t('contact.form.validation', this.currentLang) || 'Palun sisesta nimi, email ja sõnum'
                };
                return;
            }
            
            this.loading = true;
            this.submitStatus = null;
            
            try {
                const contactData = {
                    lang: this.currentLang,
                    name: this.formData.name,
                    email: this.formData.email,
                    phone: this.formData.mobile,
                    business: this.formData.business,
                    message: this.formData.message
                };
                
                const response = await fetch('/api/contact', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(contactData)
                });
                
                const result = await response.json();
                
                if (result.success) {
                    this.formData = {
                        name: '',
                        business: '',
                        email: '',
                        mobile: '',
                        message: ''
                    };
                }
                
                this.submitStatus = {
                    success: result.success,
                    message: result.message
                };
            } catch (error) {
                console.error('Viga sõnumi saatmisel:', error);
                this.submitStatus = {
                    success: false,
                    message: this.$t('contact.form.error', this.currentLang) || 'Viga sõnumi saatmisel. Palun proovi uuesti hiljem.'
                };
            } finally {
                this.loading = false;
            }
        },

        openGoogleMaps() {
            const latitude = 58.159887
            const longitude = 26.090716
            const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

            window.open(mapsUrl, '_blank');
        }
    },
    created() {
        

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>

<style scoped>
.componentWrapper {
    position: relative;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}

.texts {
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    width: 600px;
    margin-top: 25px;
    padding-right: 100px;
}
.texts h1 {
    margin: 0;
    margin-top: 5px;
    margin-bottom: 50px;
    font-size: 2.7rem;
}
.texts span {
    font-family: "Inter", sans-serif;
    color: #94a2b9;
    font-weight: 700;
}
.texts p {
    color: rgb(125, 125, 125);
    margin-bottom: 40px;
}
.contactBox {
    width: 750px;
    -webkit-box-shadow:  0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
            box-shadow:  0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;;
    padding: 50px 75px 50px 75px;
    border-radius: 10px;
    border: 1px solid rgb(240,240,240);
    background: white;
}
.contactBox label {
    font-weight: bold;
    color: rgb(100,100,100);
}
.singleContactData {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 35px;
}
.singleContactData i {
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    margin-top: auto;
    margin-bottom: auto;
    border-radius: 100%;
    padding: 14px;
    background: #E9EFFC;
    color: #5C86FF;
    font-size: 20px;
    margin-right: 20px;
}
.singleContactData p {
    margin: 0;
    font-weight: bold;
    margin-top: 3px;
    font-size: 18px;
    font-family: "Inter", sans-serif;
    color: #7888a1;
    font-weight: 500;
}
.singleContactData span {
    font-size: 14px;
    color: #5C86FF;
}
.texts span {
    margin-top: 25px;
}
@media (max-width: 1100px) {
    .componentWrapper {
        flex-direction: column;
    }
    .contactBox {
        order: 1;
        margin: 0 auto;
    }
    .texts {
        position: relative;
        width: 100%;
        order: 0;
    }
    .texts h1 {
        width: 100%;
    }
}
@media (max-width: 675px) {
    .contactBox {
        width: 100%;
        
    }
    .contactBox img:first-child {
        width: 100%;
    }
}
@media (max-width: 500px) {
    .contactBox {
        width: 100%;
        padding: 25px;
    }
    .texts {
        padding-right: 0;
    }
    .texts h1 {
        font-size: 8vw;
    }
}
@media (max-width: 450px) {
    
}
.submit-status {
    margin-top: 15px;
    padding: 10px;
    border-radius: 5px;
    font-weight: bold;
}

.success {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.error {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}
</style>